import { IAppId } from './app-id.interface';
import { IAppVersion } from './app-version.interface';
import { IVersionData } from './IVersionData';

export interface IDevApp extends IAppId {
  appVersions?: IVersionData[];
  latestAppVersion?: IAppVersion;
}

export interface IRegisterAppResponse {
  id: string;
  version: string;
}
